import { render, staticRenderFns } from "./LegalPublicityInfo.vue?vue&type=template&id=7bcb1f05&scoped=true&"
import script from "./LegalPublicityInfo.vue?vue&type=script&lang=js&"
export * from "./LegalPublicityInfo.vue?vue&type=script&lang=js&"
import style0 from "./LegalPublicityInfo.vue?vue&type=style&index=0&id=7bcb1f05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb1f05",
  null
  
)

export default component.exports